import { mkdtemp } from 'node:fs/promises'
import { join } from 'node:path'
import { tmpdir } from 'node:os'
import { GitCloneError } from '../errors.js'

export async function importRepo(
  repoUrl: string,
  targetPath?: string,
  ref?: string,
): Promise<string> {
  const { simpleGit } = await import('simple-git')

  const url = normalizeRepoUrl(repoUrl)
  const dest = targetPath ?? (await mkdtemp(join(tmpdir(), 'tonty-import-')))

  const git = simpleGit()

  try {
    if (ref && /^[0-9a-f]{7,40}$/i.test(ref)) {
      await git.init([dest])
      const repoGit = simpleGit(dest)
      await repoGit.addRemote('origin', url)
      await repoGit.fetch(['origin', ref, '--depth', '1'])
      await repoGit.checkout(['FETCH_HEAD'])
    } else if (ref) {
      await git.clone(url, dest, ['--depth', '1', '--branch', ref])
    } else {
      await git.clone(url, dest, ['--depth', '1'])
    }
  } catch (err) {
    throw new GitCloneError(url, err instanceof Error ? err.message : String(err))
  }

  return dest
}

function normalizeRepoUrl(input: string): string {
  if (input.startsWith('http://') || input.startsWith('https://')) {
    return input
  }

  if (input.startsWith('git@')) {
    return input.replace('git@github.com:', 'https://github.com/').replace(/\.git$/, '')
  }

  if (/^[a-zA-Z0-9_-]+\/[a-zA-Z0-9._-]+$/.test(input)) {
    return `https://github.com/${input}`
  }

  return input
}
